/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import Debounce from "../../../../CommonMethods/Debounce";
import { useCallback } from "react";
import { useDispatch ,useSelector} from "react-redux";
import { useLocation } from "react-router-dom";
// import { useOnClickOutside } from "../../../../CommonMethods/OutsideClick";
import { resetMonitorArray } from "../../../ManageOrganizations/monitorsSlice";
import { resetProviderArray } from "../../../ManageOrganizations/usersSlice";
import { resetObserverArray } from "../../../ManageOrganizations/observersSlice";
export default function SubdivisionDropdownWithSearch({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    subdivisionData,
    handleSubdivisionListSearch,
    subdivisionFetching,
    selectedSubdivisionName,
    setisOpensub,
    isOpensub,
    subdivisionloadingstatus,
    handleSelectionSubdivision,
    loading,
    isMonitor,
    addObserver
}
) {
    const ref = useRef();
    const location = useLocation()
    const dispatch = useDispatch()
    const [displayEmptyMsg,setDisplayEmptyMsg] = useState('')
    const [skip,setSkip]=useState(false)
    const [suggestions,setSuggestions] = useState('')
    const buttonRef = useRef(null);
    const dropdownRef=useRef(null);
    const [searchvalue ,setsearchvalue]=useState('')
    const [isOpenSubDiv, setIsOpenSubDiv] = useState(false)
   
    

    // useOnClickOutside(ref,()=>{
    //     setisOpensub(false)
    // })

    useEffect(() => {
        if (subdivisionData !== undefined) {
            if (subdivisionData?.data?.length === 0) {
                setDisplayEmptyMsg('No results found.')
                return
            }
            setDisplayEmptyMsg('')
        }
    },[subdivisionData])

    /* The `useEffect` hook is used to perform side effects in a React component. In this case, the
  effect is triggered when the `isOpenSubDiv` state variable changes. */
    useEffect(()=>{
        if(subdivisionData?.data?.length===0){
            setDisplayEmptyMsg('No results found')
        }else{
            setDisplayEmptyMsg('')
        }
      
        if(isOpensub) {
          
            value!==""&&handleSubdivisionListSearch("",'apiCallavoid')
        }
    },[isOpenSubDiv])

    const handleSubDivClick = () =>{
        setisOpensub(!isOpensub)
        setIsOpenSubDiv(!isOpenSubDiv) 
    }
    
    return (
        <>
            <div className='relative' ref={ref}>
                <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                <button 
                    ref={buttonRef} 
                    onClick={handleSubDivClick} 
                    className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} ${addObserver!==undefined?'disabled:bg-[#E7EAF4]':"disabled:opacity-50"} rounded-lg px-3.5 py-[11px] text-base font-normal 
                                 text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`} 
                    disabled={disabled}
                    id={'subdivision_button'}
                >
                    <p id={id} className={`${(selectedSubdivisionName === "" || selectedSubdivisionName === undefined ) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>{(selectedSubdivisionName === "" || selectedSubdivisionName === undefined)
                        ? placeholder
                        : selectedSubdivisionName}</p>
                    <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpensub ? "transform rotate-180" : ""}`} />
                </button>
                <ul className={`py-4 pr-1 xl:pl-4 pl-3.5 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpensub ? "" : "hidden"}`} ref={dropdownRef}>
                    <li>
                        <ul>
                            <li>
                                <div className="relative pr-3">
                                    <label htmlFor=""></label>
                                    <input
                                        type="text"
                                        autoComplete={"off"}
                                        id={isMonitor!==undefined?'search-value-subdivision':"search-value"}
                                        placeholder={addObserver!==undefined?'Search by ID/name':'Search by sub division name'}
                                        className="border border-[#C5C9DA]  rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                        onChange={(e) => {handleSubdivisionListSearch(e.target.value)}}
                                        value={value} />
                                    <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                                </div>
                            </li>
                        </ul>
                        {(subdivisionloadingstatus.status==='pending') &&
                            <div className='flex justify-center items-center mb-[40px] mt-[90px]'>             
                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  mt-[-45px] spin-animation"></div>                                                     
                            </div>
                        }
                        {(subdivisionloadingstatus.status==='fulfilled')&&displayEmptyMsg === "" ? 
                            <ul className={`max-h-[440px] overflow-auto scrollbar_gray pr-3`}>
                                {!subdivisionFetching && subdivisionData !== undefined && subdivisionData !== null && subdivisionData.data.map((item, i) => (
                                    <li key={item._id} className='flex justify-between items-center xl:p-2 py-2 pr-2 pl-1'>
                                        
                                        <div className="">
                                            <p 
                                                id={`${isMonitor!==undefined?i+'subdivision':'option-sub-division'}`}
                                                data-testid = {i + 'subdropdown'}
                                                onClick={() => handleSelectionSubdivision(item)}
                                                title={isMonitor===undefined?item?.subdivision_name:item?.sub_division_name}
                                                htmlFor={i} 
                                                className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click pl-4 more-lines"
                                            >{isMonitor===undefined?item?.subdivision_name:`${addObserver!==undefined?item?.subdivision_id:''} ${item?.sub_division_name}`}</p>
                                        
                                        </div>
                                    </li>
                                ))}
                            </ul> : 
                            <p className="mt-2 text-center">{subdivisionloadingstatus.status==='pending' ? "" :displayEmptyMsg}</p>}
                    </li>

                </ul>
            </div>
        </>
    )
}
